import React, { useState } from "react";
import {
  TouchableOpacity,
  Text,
  View,
  StyleSheet,
  Platform,
  Animated,
  Dimensions,
} from "react-native";

import AppTheme from "../AppTheme";
import Icons from "./icons";

const { height: FULL_HEIGHT, width: FULL_WIDTH } = Dimensions.get("window");

export default function SnoozeOptions({
  showSnoozed = false,
  snoozeY = 0,
  onSnooze = () => {},
  style = {},
  disabled = [],
  customOptions = null,
  disableOverlay = false,
}) {
  const [animation] = useState(new Animated.Value(1));

  const options = customOptions
    ? customOptions
    : !showSnoozed
    ? [
        { name: "Later today", icon: <Icons.SnoozeLater /> },
        { name: "Tomorrow", icon: <Icons.SnoozeTomorrow /> },
        { name: "Later this week", icon: <Icons.SnoozeLaterThisWeek /> },
        { name: "Next week", icon: <Icons.SnoozeNextWeek /> },
        { name: "Dismiss", icon: <Icons.Dismiss /> },
      ]
    : [
        // For now the names are used in backend, if changed, the backend also must be changed
        { name: "Move to feed", icon: <Icons.Bell /> },
        { name: "Delete forever", icon: <Icons.Dismiss /> },
      ];

  const handlePress = (optionName) => {
    if (disabled.includes(optionName)) return;
    onSnooze(optionName);
  };

  return (
    <>
      {disableOverlay ? null : (
        <TouchableOpacity onPress={() => handlePress("Close")}>
          <Animated.View
            style={[
              styles.bgOverlay,
              {
                opacity: animation.interpolate({
                  inputRange: [0, 1],
                  outputRange: [0, 0.84],
                }),
              },
            ]}
          />
        </TouchableOpacity>
      )}

      <View
        style={[
          styles.container,
          style,
          {
            transform: [
              {
                translateY: snoozeY,
              },
            ],
          },
        ]}
      >
        {!showSnoozed ? (
          <TouchableOpacity
            activeOpacity={0.5}
            key={-1}
            style={styles.option}
            onPress={() => handlePress("Close")}
          >
            <Text style={styles.textBold}>Snooze Until</Text>
            <Icons.Snooze />
          </TouchableOpacity>
        ) : null}

        {options.map((option, index) => (
          <TouchableOpacity
            activeOpacity={0.5}
            key={index}
            style={styles.option}
            onPress={() => handlePress(option.name)}
          >
            <Text style={[styles.text, option.style]}>{option.name}</Text>
            <View style={styles.imageRight}>{option.icon}</View>
          </TouchableOpacity>
        ))}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    right: 2,
    top: 25,
    width: 170,
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: AppTheme.toggle.bg,
    overflow: "visible",
    opacity: 0.84,
    minWidth: 140,
    zIndex: 1000,
    borderRadius: 13,
    paddingHorizontal: 8,
  },
  option: {
    height: "100%",
    width: "100%",
    paddingVertical: 6,
    flexDirection: "row",
    paddingHorizontal: 8,
    flex: 1,
    zIndex: 1000,
    height: 30,
  },
  text: {
    color: AppTheme.almostBlack,
    textTransform: "capitalize",
    fontFamily: "Montserrat",
    fontSize: 12,
    lineHeight: 18,
    width: 125,
    letterSpacing: 0.175,
    zIndex: 1000,
  },
  textBold: {
    color: AppTheme.almostBlack,
    textTransform: "capitalize",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    width: 125,
    letterSpacing: 0.175,
    zIndex: 1000,
  },
  imageRight: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    zIndex: 1000,
  },
  bgOverlay: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    position: "absolute",
    left: 0,
    bottom: 0,
    width: FULL_WIDTH,
    height: FULL_HEIGHT,
    zIndex: 999,
  },
});
